import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { useRootStore } from 'stores/RootStore'
import { Action, ActionProps } from './Action'
import cx from 'classnames'
import { BlogMetadata as BlogMetadataIcon } from 'blaze-ui/icons/36/BlogMetadata'

export const BlogMetadata = observer(({ className, ...props }: ActionProps) => {
  const { rightRailPanelStore } = useRootStore()
  const docStore = useDocStore()

  const handleClick = () => {
    docStore?.rightRailStore.setActiveTab(undefined)
    rightRailPanelStore.show('blog_metadata')
  }

  return (
    <Action
      {...props}
      className={cx(className)}
      icon={BlogMetadataIcon}
      onPress={handleClick}
      isDisabled={!!docStore.isGeneratingSuggestion}
    />
  )
})
